import React, { Component } from "react";
import { connect } from "react-redux";
import config from "config/api";
import Spinner from "components/UI/Spinner";
import i18n from "helpers/i18n";
import Immutable from "immutable";
// import Prettyfier from 'components/UI/Prettyfier';
// import HomeMember from './HomeMember';
// import HomeSpeaker from './HomeSpeaker';
import HomeVisitor from "./HomeVisitor";
import HomeSubscribe from "./HomeSubscribe";
import Header from "../Header/Header";
import HeaderContent from "../Header/HeaderContent";
import HeaderSub from "../Header/HeaderSub";
import Footer from "../Footer";
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
// import { Redirect } from 'react-router-dom'
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  fetchData,
  getDataHome,
  getLoadingError,
} from "../../ducks/asyncFetcher";
import {
  isLoggedIn,
  getCurrentUserRole,
  getCurrentUser,
  isStateKnown,
} from "ducks/authentication";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { primaryColor } from "../../helpers/colors";

const styles = (theme) => {
  return {
    root: {
      minHeight: "100%",
      // height: '100%',
      maxWidth: "1280px",
      margin: "0 auto",
    },
    wrapper: {
      // maxWidth: '1280px',
      // margin: '0 auto',
      // height: '100%',
      height: "calc(100% - 118px)",
      // background: 'linear-gradient(180deg, rgba(241,243,244,0.42) 0%, rgba(223,227,229,0.42) 100%)',
      // borderBottom: "3px " + primaryColor + " solid",
    },
    titleSmall: {
      fontSize: "2rem",
      [theme.breakpoints.down("xs")]: {
        fontSize: "1.2rem",
        textAlign: "center",
      },
    },
    headerImage: {
      textAlign: "right",
      [theme.breakpoints.down("sm")]: {
        marginTop: theme.spacing(2),
        textAlign: "center",
      },
    },
  };
};

const AF_KEY = "home";

class Home extends Component {
  componentDidMount() {
    this.props.onMount();
    // console.log('mount home')
  }

  componentDidUpdate(oldProps) {
    // if (oldProps.authStateKnown === undefined && this.props.authStateKnown !== undefined)
    //   this.props.onMount();
  }

  _getMyPastEvent() {
    const { $$data } = this.props;
    if ($$data !== undefined) {
      // console.log($$data.toJS())
      // console.log($$subscriptions)
      // console.log($$data.get('myfutureevents'))
      // console.log($$data.get('mypastevents').filter($e => $e.get('hasAttended') !== undefined && $e.get('hasAttended') !== '' && $e.get('hasAttended') !== null).toJS())
    }
    return $$data !== undefined &&
      $$data.get("mypastevents") !== undefined &&
      $$data.get("mypastevents").size > 0
      ? $$data
          .get("mypastevents")
          .filter(
            ($e) =>
              $e.get("hasAttended") !== undefined &&
              $e.get("hasAttended") !== "" &&
              $e.get("hasAttended") !== null
          )
          .get(0)
      : undefined;
  }

  render() {
    const {
      $$data,
      userRole,
      onPanelToggle,
      $$user,
      classes,
      subscribe,
      themeId,
    } = this.props;
    // console.log(isStateKnown)
    // console.log('home', {userRole})
    const $$subscriptions =
      userRole !== undefined &&
      $$data !== undefined &&
      $$data.get("myfutureevents") !== undefined
        ? $$data.get("myfutureevents").map((e) => e.get("id"))
        : Immutable.Map();

    const $$pastEvents = this._getMyPastEvent();

    let $$availableEvents;
    if ($$data !== undefined && subscribe === true) {
      if (themeId === undefined)
        $$availableEvents = $$data.get("availableEvents");
      else
        $$availableEvents = $$data
          .get("availableEvents")
          .filter(($$event) => $$event.get("themeId") === themeId);
    }
    return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
          <Header
            onPanelToggle={onPanelToggle}
            current="home"
            headerTitle={undefined}
            headerContent={<HeaderContent />}
          />
          {process.env.REACT_APP_SITE === "pneumo" ? (
            <HeaderSub inHeader size={subscribe === true ? "small" : "big"} />
          ) : undefined}
          <ScrollToTopOnMount />
          <Choose>
            <When condition={$$data !== undefined && subscribe !== true}>
              <HomeVisitor
                $$data={$$data}
                $$user={$$user}
                userRole={userRole}
                isLoggedIn={isLoggedIn}
                onSubscriptionComplete={this.props.onMount}
              />
            </When>
            <When condition={$$data !== undefined && subscribe === true}>
              <HomeSubscribe
                $$availableEvents={$$availableEvents}
                $$user={$$user}
                userRole={userRole}
                isLoggedIn={isLoggedIn}
                onSubscriptionComplete={this.props.onMount}
                $$subscriptions={$$subscriptions}
                $$pastEvents={$$pastEvents}
                themeId={themeId}
              />
            </When>
            <Otherwise>
              <div className={"Loading"}>
                <Spinner style={{ marginTop: 200 }}>Chargement...</Spinner>
              </div>
            </Otherwise>
          </Choose>
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
    authStateKnown: isStateKnown(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Home))
);



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx